import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Departamentos, Municipios } from 'src/app/models/entidades.model';
// import { MessageService } from 'primeng/api';
import { CatalogosService } from 'src/app/services/catalogos.service';

@Component({
  selector: 'app-entidades',
  templateUrl: './entidades.component.html',
  styleUrls: ['./entidades.component.css']
})
export class EntidadesComponent implements OnInit {
  tiposEntidades: SelectItem[] = [];

  tiposComprobantes: any[] = [];

  relacionTitular: any[] = [];

  hasApoderado: any[] = [];

  nombre: string = '';

  nombres: string = '';

  apellidos: string = '';

  departamento: any;

  municipio: any;

  perJuri: boolean = false;

  perNat: boolean = false;

  perExt: boolean = false;

  municipalidad: boolean = false;

  consultor: boolean = false;

  salva: boolean = false;

  extra: boolean = false;

  apoderado: boolean = false;

  duiLoading: boolean = false;

  duiTLoading: boolean = false;

  duiJLoading: boolean = false;

  duiALoading: boolean = false;
  
  duiGloading: boolean = false;

  isLoadingData: boolean = false;

  icon: any;

  form: FormGroup;

  formNatural: FormGroup;

  departamentos: any[];

  municipios: any[];

  displayModal: boolean;

  direccion = '';

  constructor(private entS: CatalogosService, private fb: FormBuilder, private route: Router) { }

  //Funcionalidad de la creacin de formulario dinamicamente
  createFormGroupEntidad(entidad: string) {
    console.log('persona capturada en el select', entidad);
    switch (entidad) {
      case 'persona.natural':
        this.perJuri = false;
        this.perNat = true;
        this.perExt = false;
        this.municipalidad = false;
        return this.fb.group({
          relacion: ['', Validators.required],
          dui: ['', Validators.required],
          nombre: [{ value: '', disabled: true }, Validators.required],
          correo: ['', Validators.required],
          imgDui: [null, Validators.required],
          Natdepartamento: [{ value: '', disabled: true }, Validators.required],
          Natmunicipio: [{ value: '', disabled: true }, Validators.required],
          direccion: [{ value: '', disabled: true }, Validators.required],
          tipoComprobante: ['', Validators.required],
          infoJuridico: this.fb.group({
            nombres: ['', Validators.required],
            apellidos: ['', Validators.required],
            telefono: ['', Validators.required],
            celular: ['', Validators.required],
            correoC: ['', Validators.required]
          }),
          relacionTitular: this.fb.group({
            duiT: ['', Validators.required],
            nombres: [{ value: '', disabled: true }, Validators.required],
            apellidos: [{ value: '', disabled: true }, Validators.required],
            addDui: ['', Validators.required],
            addNota: ['', Validators.required],
            telefonoT: ['', Validators.required],
            celularT: ['', Validators.required],
            correoRe: ['', Validators.required]
          }),
        });
      case 'persona.juridica':
        this.perJuri = true;
        this.perNat = false;
        this.perExt = false;
        this.municipalidad = false;
        return this.fb.group({
          nit: ['', Validators.required],
          nombreEntidad: [{ value: 'Pan SA. CV', disabled: true }, Validators.required],
          correo: ['', Validators.required],
          imgNit: [null, Validators.required],
          escritura: [null, Validators.required],
          modificacionConst: [null, Validators.required],
          departamento: ['', Validators.required],
          municipio: ['', Validators.required],
          direccion: ['', Validators.required],
          tipoComprobante: ['', Validators.required],
          representante: ['', Validators.required],
          salvadorenio: this.fb.group({
            dui: ['', Validators.required],
            nombres: [{ value: '', disabled: true }, Validators.required],
            apellidos: [{ value: '', disabled: true }, Validators.required],
            adjDui: [null, Validators.required],
            adjCredencial: [null, Validators.required],
            dateCredencial: ['', Validators.required],
            hasApoderado: ['', Validators.required],
            apoderado: this.fb.group({
              duiA: ['', Validators.required],
              nombresA: [{ value: '', disabled: true }, Validators.required],
              apellidosA: [{ value: '', disabled: true }, Validators.required],
              adjDuiA: ['', Validators.required],
              tipoPoder: ['', Validators.required],
              adjPoder: ['', Validators.required],
              datePoder: ['', Validators.required]
            })
          }),
          extranjero: this.fb.group({
            pasaporte: ['', Validators.required],
            nombres: [{ value: 'KICK', disabled: true }, Validators.required],
            apellidos: [{ value: 'BUTTOWSKI', disabled: true }, Validators.required],
            adjPasaporte: [null, Validators.required],
            adjCredencial: [null, Validators.required],
            dateCredencial: ['', Validators.required],
          })
        });
      case 'persona.extranjera':
        this.perJuri = false;
        this.perNat = false;
        this.perExt = true;
        this.municipalidad = false;
        return this.fb.group({
          pasaporte: ['', Validators.required],
          nombres: [{ value: 'KICK BUTTOWSKI', disabled: true }, Validators.required],
          correo: ['', Validators.required],
          adjPasaporte: [null, Validators.required],
          direccion: ['', Validators.required],
          tipoComprobante: ['', Validators.required]
        });
      case 'municipalidad':
        console.log('si entre guapo');
        this.perJuri = false;
        this.perNat = false;
        this.perExt = false;
        this.municipalidad = true;
        return this.fb.group({
          nit: ['', Validators.required],
          nombreEntidad: [{ value: 'Pan SA. CV', disabled: true }, Validators.required],
          correo: ['', Validators.required],
          adjNit: [null, Validators.required],
          direccion: ['', Validators.required],
          tipoComprobante: ['', Validators.required],
          representanteG: ['', Validators.required],
          salvadorenio: this.fb.group({
            dui: ['', Validators.required],
            nombres: [{ value: '', disabled: true }, Validators.required],
            apellidos: [{ value: '', disabled: true }, Validators.required],
            adjDui: [null, Validators.required],
            adjCredencial: [null, Validators.required],
            dateCredencial: ['', Validators.required],
          }),
          extranjero: this.fb.group({
            pasaporte: ['', Validators.required],
            nombres: [{ value: 'KICK', disabled: true }, Validators.required],
            apellidos: [{ value: 'BUTTOWSKI', disabled: true }, Validators.required],
            adjPasaporte: [null, Validators.required],
            adjCredencial: [null, Validators.required],
            dateCredencial: ['', Validators.required],
          })
        });
        case 'gubernamental':
          console.log('si entre guapo');
          this.perJuri = false;
          this.perNat = false;
          this.perExt = false;
          this.municipalidad = true;
          return this.fb.group({
            nit: ['', Validators.required],
            nombreEntidad: [{ value: 'Pan SA. CV', disabled: true }, Validators.required],
            correo: ['', Validators.required],
            adjNit: [null, Validators.required],
            direccion: ['', Validators.required],
            tipoComprobante: ['', Validators.required],
            representanteG: ['', Validators.required],
            salvadorenio: this.fb.group({
              dui: ['', Validators.required],
              nombres: [{ value: '', disabled: true }, Validators.required],
              apellidos: [{ value: '', disabled: true }, Validators.required],
              adjDui: [null, Validators.required],
              adjCredencial: [null, Validators.required],
              dateCredencial: ['', Validators.required],
            }),
            extranjero: this.fb.group({
              pasaporte: ['', Validators.required],
              nombres: [{ value: 'KICK', disabled: true }, Validators.required],
              apellidos: [{ value: 'BUTTOWSKI', disabled: true }, Validators.required],
              adjPasaporte: [null, Validators.required],
              adjCredencial: [null, Validators.required],
              dateCredencial: ['', Validators.required],
            })
          });
          case 'autonoma':
            console.log('si entre guapo');
            this.perJuri = false;
            this.perNat = false;
            this.perExt = false;
            this.municipalidad = true;
            return this.fb.group({
              nit: ['', Validators.required],
              nombreEntidad: [{ value: 'Pan SA. CV', disabled: true }, Validators.required],
              correo: ['', Validators.required],
              adjNit: [null, Validators.required],
              direccion: ['', Validators.required],
              tipoComprobante: ['', Validators.required],
              representanteG: ['', Validators.required],
              salvadorenio: this.fb.group({
                dui: ['', Validators.required],
                nombres: [{ value: '', disabled: true }, Validators.required],
                apellidos: [{ value: '', disabled: true }, Validators.required],
                adjDui: [null, Validators.required],
                adjCredencial: [null, Validators.required],
                dateCredencial: ['', Validators.required],
              }),
              extranjero: this.fb.group({
                pasaporte: ['', Validators.required],
                nombres: [{ value: 'KICK', disabled: true }, Validators.required],
                apellidos: [{ value: 'BUTTOWSKI', disabled: true }, Validators.required],
                adjPasaporte: [null, Validators.required],
                adjCredencial: [null, Validators.required],
                dateCredencial: ['', Validators.required],
              })
            });
      default:
        return this.fb.group({});
    }
  }

  // consulta de dui
  duiInfo(input: any) {
    if (input) {
      this.form.get(input)?.valueChanges.subscribe(value => {
        console.log('esto', value);
        if (value && value.length === 10) {
          this.duiLoading = true;
          this.entS.getPersona(value).subscribe((persona: any) => {
            this.nombre = persona?.data.persona.nombre_completo;
            this.nombres = persona?.data.persona.nombres;
            this.apellidos = persona?.data.persona.apellidos;

            const departamento = persona?.data.persona.departamento;
            const municipio = persona?.data.persona.municipio;
            this.municipios.filter((municipio: any) => {
              if (municipio.label === persona?.data.persona.municipio) {
                this.municipio = {
                  value: municipio.value,
                  label: municipio.label
                }
                this.form.get('entidadForm.Natmunicipio')?.enable();
              }
            });
            this.departamentos.filter((departamento: any) => {
              if (departamento.label === persona?.data.persona.departamento) {
                this.departamento = {
                  value: departamento.value,
                  label: departamento.label
                }
                this.form.get('entidadForm.Natdepartamento')?.enable();
              }
            })
            const direccion = `${departamento}, ${municipio}`;
            this.form.get('entidadForm.nombre')?.setValue(this.nombre);
            this.form.get('entidadForm.direccion')?.setValue(direccion);
            if (direccion) {
              this.form.get('entidadForm.direccion')?.enable();
            }
            this.duiLoading = false;
          });
        }
      });
    }
  }

  duiInfoRelacion(input:any, conection: string) {
    if (input) {
      this.form.get(input)?.valueChanges.subscribe(value => {
        if (value && value.length === 10) {
          this.duiTLoading = true;
          console.log('AQUI ESTOY WEY', conection);
          if (conection === 'salva') {
            console.log('AQUI ESTAMOS MANCO');
            this.duiJLoading = true;
            this.duiGloading = true;
          } else if (conection === 'si') {
            this.duiALoading = true;
          }

          this.entS.getPersona(value).subscribe((persona: any) => {
            if (conection === 'consultor') {
              this.form.get('entidadForm.relacionTitular.nombres')?.setValue(persona?.data.persona.nombres);
              this.form.get('entidadForm.relacionTitular.apellidos')?.setValue(persona?.data.persona.apellidos);
              this.direccion = `${persona?.data.persona.departamento}, ${persona?.data.persona.municipio}`;

              this.duiTLoading = false;
            } else if (conection === 'salva') {
              this.form.get('entidadForm.salvadorenio.nombres')?.setValue(persona?.data.persona.nombres);
              this.form.get('entidadForm.salvadorenio.apellidos')?.setValue(persona?.data.persona.apellidos);
              this.duiGloading = false;
              this.duiJLoading = false;
            } else if (conection === 'si') {
              this.form.get('entidadForm.salvadorenio.apoderado.nombresA')?.setValue(persona?.data.persona.nombres);
              this.form.get('entidadForm.salvadorenio.apoderado.apellidosA')?.setValue(persona?.data.persona.apellidos);
              this.duiALoading = false;
            }
          });
        }
      })
    }
  }

  relacionNat(input: any, person: string) {
    if(person === 'persona.natural') {
      this.form.get(input).valueChanges.subscribe((valorRelacion) => {
        console.log(valorRelacion);
        // const relacionTitularGroup = this.form.get('relacionNat.relacionTitular');
        if (valorRelacion.value === 'titular') {
          this.consultor = false;
          // relacionTitularGroup.get('duiT').clearValidators();
          // relacionTitularGroup.get('nombres').clearValidators();
          // relacionTitularGroup.get('apellidos').clearValidators();
          // // relacionTitularGroup.get('addDui').clearValidators();
          // // relacionTitularGroup.get('addNota').clearValidators();
          // relacionTitularGroup.get('telefonoT').clearValidators();
          // relacionTitularGroup.get('celularT').clearValidators();
          // relacionTitularGroup.get('correoRe').clearValidators();
          // relacionTitularGroup.clearValidators();
          // // Actualizar las validaciones y estado del formulario
          // relacionTitularGroup.updateValueAndValidity();
          console.log(this.consultor);
        } else if (valorRelacion.value === 'consultor') {
          this.consultor = true;
          console.log(this.consultor);
          this.duiInfoRelacion('entidadForm.relacionTitular.duiT', valorRelacion.value);
          // relacionTitularGroup.get('duiT').setValidators(Validators.required);
          // relacionTitularGroup.get('nombres').setValidators(Validators.required);
          // relacionTitularGroup.get('apellidos').setValidators(Validators.required);
          // // relacionTitularGroup.get('addDui').setValidators(Validators.required);
          // // relacionTitularGroup.get('addNota').setValidators(Validators.required);
          // relacionTitularGroup.get('telefonoT').setValidators(Validators.required);
          // relacionTitularGroup.get('celularT').setValidators(Validators.required);
          // relacionTitularGroup.get('correoRe').setValidators(Validators.required);
          // relacionTitularGroup.updateValueAndValidity();
        }
        // relacionTitularGroup.updateValueAndValidity();
      });
    } else if (person === 'persona.juridica') {
      // Funcionalidad de form Juridico
      this.form.get(input).valueChanges.subscribe(representante => {
        console.log('Seleccionaste que eres', representante);
        if (representante === 'salva') {
          this.salva = true;
          this.extra = false;
          this.duiInfoRelacion('entidadForm.salvadorenio.dui', representante)
          this.form.get('entidadForm.salvadorenio.hasApoderado').valueChanges.subscribe(hasApoderado => {
            console.log('A VERRR', hasApoderado.value);
            if (hasApoderado.value === 'si') {
              this.apoderado = true;
              this.duiInfoRelacion('entidadForm.salvadorenio.apoderado.duiA', hasApoderado.value)
              console.log('YA LO CAMBIE WEY');
            } else {
              this.apoderado = false;
            }
          });
        } else if (representante === 'extra') {
          this.extra = true;
          this.salva = false;
        } else {
          this.salva = false;
          this.extra = false;
        }
      });
    } else if (person === 'municipalidad' || person === 'gubernamental' || person === 'autonoma') {
      console.log('entre', input);
      this.form.get(input).valueChanges.subscribe(representante => {
        console.log('Seleccionaste que eres', representante);
        if (representante === 'salva') {
          this.salva = true;
          this.extra = false;
          this.duiInfoRelacion('entidadForm.salvadorenio.dui', representante)
        } else if (representante === 'extra') {
          this.extra = true;
          this.salva = false;
        } else {
          this.salva = false;
          this.extra = false;
        }
      });
    }
  }

  ngOnInit(): void {
    this.icon = 'pi pi-chevron-down';
    this.isLoadingData = true;
    this.form = this.fb.group({
      tipoEntidad: ['', Validators.required],
      entidadForm: this.fb.group({})
    });

    // Obtener los Tipos de Entidades, municipio, departamentos y tipo de comprobante de sus respectivos Catálogos para llenar los selects
    this.entS.getEntidades().subscribe(entidades => {
      this.tiposEntidades = entidades.data.map(item => ({
        label: item.attributes.nombre,
        value: item.attributes.codigo
      }));
      this.isLoadingData = false;
    });

    this.entS.getDepartamentos().subscribe((departamentos) => {
      console.log(departamentos);
      console.log(typeof (departamentos));
      this.departamentos = departamentos.map((depa: Departamentos) => ({
        label: depa.nombre,
        value: depa.id
      }));
      console.log(typeof (this.departamentos));
    });

    this.entS.getMunicipios().subscribe((municipios) => {
      this.municipios = municipios.map((municipio: Municipios) => ({
        label: municipio.nombre,
        value: municipio.id
      }))
    });

    this.entS.getTipoComprobante().subscribe(comprobantes => {
      this.tiposComprobantes = comprobantes.data.map(comprobante => ({
        label: comprobante.attributes.nombre,
        value: comprobante.attributes.codigo
      }));
      this.isLoadingData = false;
    });

    // Ver las opciones seleccionadas
    this.form.get('tipoEntidad')?.valueChanges.subscribe(tipo => {
      if (tipo) {
        const entidadFormGroup = this.createFormGroupEntidad(tipo.value);
        console.log('desde el cambio del select', tipo);
        this.form.setControl('entidadForm', entidadFormGroup);
        console.log('Ahora soy esto', this.form.get('entidadForm'));
        if (tipo.value === 'persona.natural') {
          this.duiInfo('entidadForm.dui');
          this.relacionNat('entidadForm.relacion', tipo.value);
        } else if (tipo.value === 'persona.juridica') {
          this.relacionNat('entidadForm.representante', tipo.value);
        } else if (tipo.value === 'municipalidad' || tipo.value === 'gubernamental' || tipo.value === 'autonoma') {
          console.log('estoy aqui y soy una persona', tipo.value);
          this.relacionNat('entidadForm.representanteG', tipo.value);
        }
      }
      // switch (tipo.value) {
      //   case 'persona.juridica':
      //     this.perJuri = true;
      //     this.perNat = false;
      //     this.perExt = false;
      //     this.municipalidad = false;
      //     this.form.get('natural').reset();
      //     this.form.get('perExtranjera').reset();
      //     this.form.get('juridico').reset();
      //     this.form.get('muniGubAut').reset();
      //     break;
      //   case 'persona.natural':
      //     this.perJuri = false;
      //     this.perNat = true;
      //     this.perExt = false;
      //     this.municipalidad = false;
      //     this.form.get('juridico').reset();
      //     this.form.get('perExtranjera').reset();
      //     this.form.get('natural').reset();
      //     this.form.get('muniGubAut').reset();
      //     break;
      //   case 'persona.extranjera':
      //     this.perExt = true;
      //     this.perJuri = false;
      //     this.perNat = false;
      //     this.municipalidad = false;
      //     this.form.get('juridico').reset();
      //     this.form.get('natural').reset();
      //     this.form.get('perExtranjera').reset();
      //     this.form.get('muniGubAut').reset();
      //     break;
      //   case 'municipalidad' || 'gubernamental' || 'autonoma':
      //     this.municipalidad = true;
      //     this.perJuri = false;
      //     this.perNat = false;
      //     this.perExt = false;
      //     this.form.get('juridico').reset();
      //     this.form.get('natural').reset();
      //     this.form.get('muniGubAut').reset();
      //     this.form.get('perExtranjera').reset();
      //     break;
      //   default:
      //     break;

      // }
    });

    console.log('esto tengo', this.form.get('entidadForm'));

    this.relacionTitular = [
      {
        label: 'Titular',
        value: 'titular'
      },
      {
        label: 'Consultor',
        value: 'consultor'
      }
    ];

    this.hasApoderado = [
      {
        label: 'Si',
        value: 'si'
      },
      {
        label: 'No',
        value: 'no'
      }
    ];

    this.form.valueChanges.subscribe(() => {
      // this.form.updateValueAndValidity();
      if (this.form.valid) {
        console.log('El formulario es válido');
        // Aquí puedes ejecutar cualquier código adicional que desees cuando el formulario sea válido
      } else {
        console.log('El formulario es inválido');
        console.log(this.form.value);
        console.log(this.form.get('entidadForm').value);
        // Aquí puedes ejecutar cualquier código adicional que desees cuando el formulario sea inválido
      }
    });
  }

  onFileSelected(event: any, input: string) {
    // Obtiene el archivo seleccionado
    const file = event.files[0];

    console.log(file);

    // Actualiza el valor del control 'imgDui' con el archivo seleccionado
    if (input === 'imgDui') {
      console.log(input);
      this.form.get(`natural.${input}`).setValue(file);
    } else if (input === 'addDui') {
      console.log(input);
      this.form.get(`natural.relacionTitular.${input}`).setValue(file);
    } else if (input === 'addNota') {
      this.form.get(`natural.relacionTitular.${input}`).setValue(file);
    } else if (input === 'imgNit') {
      this.form.get(`juridico.${input}`).setValue(file);
    } else if (input === 'escritura') {
      this.form.get(`juridico.${input}`).setValue(file);
    } else if (input === 'modificacionConst') {
      this.form.get(`juridico.${input}`).setValue(file);
    } else if (input === 'adjDui') {
      this.form.get(`juridico.salvadorenio${input}`).setValue(file);
    } else if (input === 'adjCredencial') {
      this.form.get(`juridico.salvadorenio${input}`).setValue(file);
    } else if (input === 'adjDuiA') {
      this.form.get(`juridico.salvadorenio.apoderado.${input}`).setValue(file);
    } else if (input === 'adjPoder') {
      this.form.get(`juridico.salvadorenio.apoderado.${input}`).setValue(file);
    } else if (input === 'adjPasaporte') {
      this.form.get(`juridico.extranjero.${input}`).setValue(file);
    } else if (input === 'adjCredencial') {
      this.form.get(`juridico.extranjero.${input}`).setValue(file);
    } else if (input === 'adjPasaporte') {
      this.form.get(`perExtranjera.${input}`).setValue(file);
    } else if (input === 'adjNit') {
      this.form.get(`muniGubAut.${input}`).setValue(file);
    } else if (input === 'adjDui') {
      this.form.get(`muniGubAut.salvadorenio.${input}`).setValue(file);
    } else if (input === 'adjCredencial') {
      this.form.get(`muniGubAut.salvadorenio.${input}`).setValue(file);
    } else if (input === 'adjPasaporte') {
      this.form.get(`muniGubAut.extranjero.${input}`).setValue(file);
    } else if (input === 'adjCredencial') {
      this.form.get(`muniGubAut.extranjero.${input}`).setValue(file);
    }

    console.log('Aver si cambia el value', this.form.get('juridico'));
  }

  send() {
    const direccion = this.direccion;
    const request = {
      codigo_entidad: this.form.get('tipoEntidad').value.value,
      tipo_relacion: this.form.get('entidadForm.relacion').value.value,
      codigo_comprobante: this.form.get('entidadForm.tipoComprobante').value.value,
      numero_documento: this.form.get('entidadForm.dui').value,
      nombres: this.nombres,
      apellidos: this.apellidos,
      nombre_entidades: this.form.get('entidadForm.nombre').value,
      emails_contacto: this.form.get('entidadForm.correo').value,
      direccion_residencia: this.form.get('entidadForm.direccion').value,
      id_departamento: this.form.get('entidadForm.Natdepartamento').value.value,
      id_municipio: this.form.get('entidadForm.Natmunicipio').value.value,
      nombresC: this.form.get('entidadForm.infoJuridico.nombres').value,
      apellidosC: this.form.get('entidadForm.infoJuridico.apellidos').value,
      telefonoC: this.form.get('entidadForm.infoJuridico.telefono').value,
      celularC: this.form.get('entidadForm.infoJuridico.celular').value,
      email: this.form.get('entidadForm.infoJuridico.correoC').value,
      dui: this.form.get('entidadForm.relacionTitular.duiT').value,
      nombre: this.form.get('entidadForm.relacionTitular.nombres').value,
      apellido: this.form.get('entidadForm.relacionTitular.nombres').value,
      telefono: this.form.get('entidadForm.relacionTitular.telefonoT').value,
      correo: this.form.get('entidadForm.relacionTitular.correoRe').value,
      direccion: direccion
    };
    
    this.entS.guardarEntidadNatural(request).subscribe(value => {
      console.log(value);
      this.displayModal = true;
      this.form.reset();
    });
    

    if (this.form.valid) {
      const opcionElegida = this.form.get('tipoEntidad')?.value;
      const datosNatural = this.formNatural.value;

      console.log('Opcion seleccionada', opcionElegida);
      console.log('datos del segundo form', datosNatural);
    }
  }

  continuar() {
    this.displayModal = true;
    this.route.navigate(['/lista-entidades']);
  }
}